
import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace, Getter } from "vuex-class"

import CaseFilters from "@/components/CaseList/CaseFilters.vue"
import SlideMenu from "@/components/SlideMenu.vue"
import QuickCreate from "@/components/CaseDetails/QuickCreate.vue"

import HeaderBar from "./HeaderBar.vue"
import SideBar from "./SideBar.vue"

import { CurrentUser } from "@/types/user"

import { ViewsService } from "@/services/viewsService"
import QuickCreateMenu from "@/components/CaseDetails/QuickCreateMenu.vue"

const caseStore = namespace("cases")

@Component({
	components: {
		"quick-create-menu": QuickCreateMenu,
		"case-filters": CaseFilters,
		"quick-create": QuickCreate,
		"header-bar": HeaderBar,
		"side-bar": SideBar
	}
})
export default class Page extends Vue {
	$refs!: {
		slideMenu: SlideMenu
	}

	@Prop(String) private readonly title!: string;

	@Getter("getMe")
	public me!: CurrentUser;

	@Getter("getHasIntegrations") hasIntegrations!: boolean

	@Getter("getScreenWidth")
	public screenWidth!: number;

	@caseStore.State viewsService!: ViewsService;

	@Getter("getCaseName") private readonly caseName!: string;
	@Getter("getRecordName") private readonly recordName!: string;

	// @caseStore.State
	// private caseToast!: string | null

	// @caseStore.Mutation
	// private setCaseToast!: (message: string | null) => void

	// @State
	// private userToast!: string | null

	// @Mutation
	// private setUserToast!: (message: string | null) => void

	// @Watch("caseToast")
	// onCaseToastChanged (newMessage: string | null) {
	// 	if (newMessage) {
	// 		this.$bvToast.toast(newMessage, {
	// 			title: this.getRecordName,
	// 			variant: "danger",
	// 			solid: true,
	// 			autoHideDelay: 10000
	// 		})

	// 		this.setCaseToast(null)
	// 	}
	// }

	// @Watch("userToast")
	// onUserToastChanged (newMessage: string | null) {
	// 	if (newMessage) {
	// 		this.$bvToast.toast(newMessage, {
	// 			title: "Message",
	// 			variant: "danger",
	// 			solid: true,
	// 			autoHideDelay: 5000
	// 		})

	// 		this.setUserToast(null)
	// 	}
	// }

	// public async mounted () {
	// 	if (this.screenWidth <= 800) {
	// 		this.viewsService.loadViews()
	// 	}
	// 	this.onCaseToastChanged(this.caseToast)
	// }

	// /** Displays list of routes user can navigate to */
	// public get displayRoutes (): any[] {
	// 	return (this.$router as any).options.routes
	// 		.filter((route: any) => {
	// 			return route && route.meta && route.meta.icon
	// 		})
	// 		.map((route: any) => {
	// 			return {
	// 				name: route.name,
	// 				icon: route.meta.icon
	// 			}
	// 		})
	// }

	// public get currentRouteName () {
	// 	return this.$router.currentRoute.name
	// }

	// public get activeViewId (): string | null {
	// 	if (this.$router.currentRoute.name === "overview") {
	// 		return this.viewsService.activeViewId
	// 	}
	// 	return null
	// }

	// public get viewsSummary () {
	// 	if (!this.viewsService.viewSummary) return null
	// 	return this.viewsService.viewSummary.summary
	// }

	// public gotoPage () {
	// 	this.$router.push({ name: "overview" })
	// }

	// private openMenu (): void {
	// 	this.$refs.slideMenu.open()
	// }

	public newCase (): void {
		this.$router.push({ path: "/cases/New" })
	}

	// public async changeView (viewId: string | null) {
	// 	this.viewsService.activeViewId = viewId
	// 	if (this.$router.currentRoute.name === "overview") {
	// 		this.viewsService.loadViews()
	// 		this.$refs.slideMenu.close()
	// 	} else {
	// 		this.$router.push({ path: "/cases" })
	// 	}
	// }
}

